export default __webpack_public_path__ + "static/media/hugging.680c5d04.png";